module.exports = __webpack_public_path__ + "img/bg-2.0b9e3122.png";